export interface NavigationState {
    hasDirtyForm: boolean;
    routeOnDirty: string;
    currentRoute: string;
    previousRoute: string;
    trigger: boolean;
    allowUnload: boolean;
}

export const initialNavigationState: NavigationState = {
    hasDirtyForm: false,
    routeOnDirty: null,
    currentRoute: null,
    previousRoute: null,
    trigger: false,
    allowUnload: false
}